class ImageSliderWithText extends HTMLElement {
    constructor() {
      super();
      // Get section ID from data attribute for explicit element targeting
      this.sectionId = this.dataset.sectionId;
      this.autoplay = this.dataset.autoplay === 'true';
      this.videoPlayers = {};
      this.checkYTInterval = null;
    }

    connectedCallback() {
      // Find elements using unique IDs scoped to this section instance
      const sliderMount = this.querySelector(`#image-slider-with-text--${this.sectionId}`);
      const prevButton = this.querySelector(`#image-slider-prev--${this.sectionId}`);
      const nextButton = this.querySelector(`#image-slider-next--${this.sectionId}`);
      
      const slides = sliderMount?.querySelectorAll('.keen-slider__slide');
      if (window.KeenSlider && sliderMount && slides && slides.length > 0) {

        this.slider = new KeenSlider(sliderMount, {
          loop: true,
          mode: 'snap',
          slides: {
            perView: 1,
            spacing: 0
          }
        }, [
          (slider) => {
            slider.on("created", () => {
              if (prevButton) {
                prevButton.addEventListener("click", () => {
                  slider.prev();
                });
              }
              if (nextButton) {
                nextButton.addEventListener("click", () => {
                  slider.next();
                });
              }
              // Force update after short delay to handle layout shifts
              setTimeout(() => {
                 slider.update();
              }, 200);
            });

            // Handle slide changes to pause/play videos
            slider.on("slideChanged", () => {
              this.handleSlideChange(slider);
            });
          }
        ]);

        // Initialize YouTube players for video blocks
        this.initYouTubePlayers();
      }
    }

    disconnectedCallback() {
      if (this.slider) {
        this.slider.destroy();
      }
      this.cleanup();
    }

    cleanup() {
      if (this.checkYTInterval) {
        clearInterval(this.checkYTInterval);
        this.checkYTInterval = null;
      }
      // Destroy all video players
      Object.values(this.videoPlayers).forEach(player => {
        if (player && typeof player.destroy === 'function') {
          player.destroy();
        }
      });
      this.videoPlayers = {};
    }

    handleSlideChange(slider) {
      const currentSlide = slider.track.details.abs;
      const sliderMount = this.querySelector(`#image-slider-with-text--${this.sectionId}`);
      const slides = sliderMount?.querySelectorAll('.keen-slider__slide');
      const currentSlideElement = slides[currentSlide];
      
      // Pause all videos
      Object.values(this.videoPlayers).forEach(player => {
        if (player && typeof player.pauseVideo === 'function') {
          try {
            player.pauseVideo();
          } catch (e) {
            // Player might not be ready
          }
        }
      });
    }

    initYouTubePlayers() {
      const videoBlocks = this.querySelectorAll('.image-slider-with-text__video-item[data-video-id]');
      if (videoBlocks.length === 0) return;

      // Load YouTube API if not already loaded
      if (!window.YT) {
        var tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      }

      // Wait for YouTube API to be ready
      this.checkYTInterval = setInterval(() => {
        if (window.YT && window.YT.Player) {
          clearInterval(this.checkYTInterval);
          this.createVideoPlayers(videoBlocks);
        }
      }, 100);

      setTimeout(() => {
        if (this.checkYTInterval) {
          clearInterval(this.checkYTInterval);
        }
      }, 10000);
    }

    createVideoPlayers(videoBlocks) {
      videoBlocks.forEach((block) => {
        const blockId = block.dataset.blockId;
        const videoId = block.dataset.videoId;
        const playerId = `player-${this.sectionId}-${blockId}`;
        const playerElement = block.querySelector(`#${playerId}`);

        if (!playerElement || !videoId) return;

        try {
          const player = new YT.Player(playerId, {
            height: '100%',
            width: '100%',
            videoId: videoId,
            playerVars: {
              'playsinline': 1,
              'rel': 0,
              'autoplay': 0 // Don't autoplay immediately, handle via slide change
            },
            events: {
              'onReady': () => {
                // Store player reference
                this.videoPlayers[blockId] = player;
              }
            }
          });
        } catch (e) {
          console.warn('Failed to create YouTube player:', e);
        }
      });
    }
  }

  if (!customElements.get('image-slider-with-text')) {
    customElements.define('image-slider-with-text', ImageSliderWithText);
  }